import axios from 'axios';
import { ApiDay, DutyPeriodSchedule } from '@/rennovation/planning-view/types/api/days-response';

export class DayApiService {
	private baseUrl = '/api/days';

	async findDays(from: string, to: string): Promise<ApiDay[]> {
		const response = await axios.get(`${this.baseUrl}?from=${from}&to=${to}&sort=date`);
		return response.data;
	}

	async getDateRangeForDayStatuses(): Promise<DutyPeriodSchedule> {
		const response = await axios.get(`${this.baseUrl}/date-range-by-status`);
		return response.data;
	}

	async updateDayStatus(dayId, status) {
		if (dayId) {
			return axios.patch(`/api/days/${dayId}`, status);
		}
		return axios.patch(`/api/days/`, status);
	}
}
